import { makeStyles } from 'tss-react/mui';

const quoteStyles = makeStyles()({
    mainblock:{
        background:"#fff",
        padding:"20px",
        height:"calc(100vh - 100px)",
        flexWrap:"nowrap",
        overflow:"auto"
    },
    footer: {
        position: "absolute",
        bottom: 0,
        zIndex: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        // marginTop: "30px",
        background: "#3B78CE",
        padding: "16px 50px",
        // "@media screen and (max-width:1001px)": {
        //     display: "none !important",
        // },

    },
    siteMap: {
        display: "inline-flex",
        listStyle: "none",
        padding: "0 10px",
    },
    CopyRightText: {
        color: "#FFFFFF",
        fontSize: "13px",
        fontWeight: "600",
        lineHeight: "18px"
    },
    site: {
        padding: "0px 20px",
        borderRight: "1px solid white",
        "@media screen and (max-width:899px)": {
            padding: "0px 20px 0px 0px !important",
        },
    },
    icon: {
        fontSize: "medium !important"
    },
    heading:{
    fontSize:"15px",
      color:"#000",
      fontWeight:"600",
      paddingLeft:"5px"
    },

    iframeCtn: { 
      width: "100%", 
      marginTop: "15px", 
      height: "100%" 
    }
});

export default quoteStyles;